.container {
  padding: 16px;
  max-width: 400px;
  margin: 0 auto;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: var(--tg-theme-text-color, #fff);
}

.closeBtn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: var(--tg-theme-hint-color, #999);
  padding: 4px 8px;
}

.centers {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 16px;
}

.centerItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--tg-theme-secondary-bg-color, #1a1a2e);
  border-radius: 12px;
  padding: 12px 20px;
  min-width: 120px;
}

.centerLabel {
  font-size: 11px;
  color: var(--tg-theme-hint-color, #999);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.centerValue {
  font-size: 28px;
  font-weight: 700;
  color: var(--tg-theme-text-color, #fff);
  margin: 4px 0 2px;
}

.centerName {
  font-size: 13px;
  color: var(--tg-theme-subtitle-text-color, #aaa);
}

.octagonWrapper {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lineItem {
  background: var(--tg-theme-secondary-bg-color, #1a1a2e);
  border-radius: 10px;
  padding: 12px 14px;
}

.lineName {
  font-size: 14px;
  font-weight: 600;
  color: var(--tg-theme-text-color, #fff);
  margin-bottom: 4px;
}

.lineValues {
  font-size: 13px;
  color: var(--tg-theme-subtitle-text-color, #aaa);
  line-height: 1.5;
}

.lineValues strong {
  color: var(--tg-theme-text-color, #fff);
}

.interpretBtn {
  width: 100%;
  padding: 14px 16px;
  margin-top: 16px;
  background: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}

.interpretBtn:active {
  opacity: 0.7;
}
